import React from "react";
import emailjs from "emailjs-com";
import { Form } from "react-bootstrap";
import swal from 'sweetalert';

export default function MailClient() {
  function sendEmail(e) {
    e.preventDefault();

    const email = e.target.user_email.value.trim();
    const contact = e.target.contact_number.value.trim();

    if (!email && !contact) {
      swal({
        title: 'Missing Information',
        text: 'Please enter either an Email address or a Contact number.',
        icon: 'error',
        button: 'OK',
      });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      swal({
        title: 'Invalid Email',
        text: 'Please enter a valid email address.',
        icon: 'error',
        button: 'OK',
      });
      return;
    }

    const contactNumberRegex = /^\d{8,}$/;
    if (contact && !contactNumberRegex.test(contact)) {
      swal({
        title: 'Invalid Contact Number',
        text: 'Contact number should be at least 8 digits.',
        icon: 'error',
        button: 'OK',
      });
      return;
    }

    emailjs
      .sendForm(
        "service_r97pgaj",
        "template_l21vi4w",
        e.target,
        "user_58IRKUJ9wfCmk1ka8yigY"
      )
      .then(
        (result) => {
          console.log(result.text);
          if (result.text === 'OK') {
            swal({
              title: 'Thank you',
              text: 'Request Submitted Successfully !!',
              icon: 'success',
              button: 'OK'
            });

            // ✅ Fire Google Ads Conversion Event
            if (typeof window.gtag === "function") {
              window.gtag("event", "conversion", {
                send_to: "AW-17257042374/BOAhCIukmeEaEMaj5qRA",
                value: 1.0,
                currency: "INR"
              });
              console.log("Google Ads conversion event sent");
            } else {
              console.warn("gtag is not defined. Make sure Google Ads script is loaded.");
            }
          }
        },
        (error) => {
          console.log("EmailJS Error:", error.text);
        }
      );

    e.target.reset();
  }

  return (
    <div>
      <style>{"body { background-color: #0F092B; }"}</style>
      <Form onSubmit={sendEmail}>
        <Form.Group controlId="exampleForm.ControlInput1">
          <Form.Label style={{ color: "white" }}>Email address</Form.Label>
          <Form.Control
            type="email"
            name="user_email"
            placeholder="name@example.com"
          />
        </Form.Group>

        <Form.Group controlId="exampleForm.ControlInput2">
          <Form.Label style={{ color: "white" }}>Name</Form.Label>
          <Form.Control
            type="text"
            name="user_name"
            placeholder="name"
          />
        </Form.Group>

        <Form.Group controlId="exampleForm.ControlInput3">
          <Form.Label style={{ color: "white" }}>Contact Number</Form.Label>
          <Form.Control
            type="text"
            name="contact_number"
            placeholder="contact number"
          />
        </Form.Group>

        <Form.Group controlId="exampleForm.ControlTextarea1">
          <Form.Label style={{ color: "white" }}>Description</Form.Label>
          <Form.Control
            as="textarea"
            name="message"
            rows={3}
            placeholder="Description"
          />
        </Form.Group>

        <Form.Group controlId="exampleForm.ControlInput4">
          <Form.Control
            style={{ background: "green", color: "black" }}
            type="submit"
            value="Send"
          />
        </Form.Group>
      </Form>
      <div>&nbsp;</div>
    </div>
  );
}
